import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { OrganisationContext } from '../../context/organisationContext';
import Box from '../elements/box';
import Checkbox from '../elements/checkbox';

const PreferanceInfo = ({ preferance, setPreferance }) => {
  const { t } = useTranslation();
  const { vendor } = useContext(OrganisationContext);

  return (
    <PreferanceInfoWrapper>
      <Box title={t('YOUR_CONTACT_PREFERENCES')}>
        <div className="flex-column w-full mt-8 col-gap-6">
          <p className="roboto-regular-text main-grey-text mt-2">{t('PREFERANCE_PARAGRAPH_2')}</p>
          <div className="border radius-4 flex-column pxy-6 mt-8 white-background">
            <label className="roboto-regular-text">
              {vendor?.name} would like to keep in touch and tell you about how your support is helping and their future
              work. Please tick below if you would like to hear from them by:
            </label>
            <div className="preference-choices mt-6">
              <Checkbox
                name={t('RECEIVE_EMAIL')}
                checked={preferance.email}
                onChange={value => setPreferance({ ...preferance, email: value })}
              />
              <Checkbox
                name={t('RECEIVE_SMS_MESSAGES')}
                checked={preferance.sms}
                onChange={value => setPreferance({ ...preferance, sms: value })}
              />
              <Checkbox
                name={t('RECEIVE_PHONE_CALL')}
                checked={preferance.phoneCall}
                onChange={value => setPreferance({ ...preferance, phoneCall: value })}
              />
            </div>
          </div>
          <div className="border radius-4 flex-column pxy-6 mt-8 white-background">
            <label className="roboto-regular-text">{t('LOTTERY_CONSET_LINES')}</label>
            <div className="preference-choices mt-6">
              <Checkbox
                name={t('RECEIVE_EMAIL')}
                checked={preferance.zenEmail}
                onChange={value => setPreferance({ ...preferance, zenEmail: value, zenNoThanks: false })}
              />
              <Checkbox
                name={t('RECEIVE_SMS_MESSAGES')}
                checked={preferance.zenSms}
                onChange={value => setPreferance({ ...preferance, zenSms: value, zenNoThanks: false })}
              />
              <Checkbox
                name={t('RECEIVE_PHONE_CALL')}
                checked={preferance.zenPost}
                onChange={value => setPreferance({ ...preferance, zenPost: value, zenNoThanks: false })}
              />
            </div>
            {/* commented out as per the ticket: https://zervio.atlassian.net/browse/ZPUK-187 */}
            {/* <div className="flex col-gap-4 mt-6">
              <label className="roboto-regular-text choice-label flex items-center">
                Or tick here if you would not like to receive any exclusive offers or discounts:
              </label>
              <Checkbox
                checked={preferance.zenNoThanks}
                onChange={value =>
                  setPreferance({
                    ...preferance,
                    zenNoThanks: value,
                    zenEmail: false,
                    zenSms: false,
                    zenPost: false,
                  })
                }
              />
            </div> */}
          </div>
        </div>
      </Box>
    </PreferanceInfoWrapper>
  );
};

export const PreferanceInfoWrapper = styled.div`
  .preference-choices {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }

  .no-preference-choice {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;

    .choice-label {
      grid-column: span 2;
    }
  }

  @media (max-width: 961px) {
    .preference-choices {
      grid-template-columns: repeat(1, 1fr);
      row-gap: 24px;
    }
  }
`;

export default PreferanceInfo;
